<template>
  <div class="footer">
    <div class="footer-main">
      <p>{{data.text1}}</p>
      <p>{{data.text2}}</p>
      <p>{{data.text3}}</p>
      <!-- <p><router-link target="_blank" v-if="data.privacy" :to="data.url">{{data.privacy}}</router-link> </p> -->
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        data:''
      }
    },
    props: {
        resData: {
        }
    },
    watch: {
        resData(newData){
            this.data=newData;
        }
    },
  }
</script>

<style scoped>
  .footer{
    padding-top: 110px;
    /* height: 230px; */
    background: url('~@/assets/images/footer-bg1.png') right no-repeat, url('~@/assets/images/footer-bg2.png') left no-repeat,#F7F7F7;
    background-size: auto 100%;
    box-sizing: border-box;
  }
  .footer-main{
    display: block;
    height: 100%;
    width: 100%;
    background-color: #333;
    text-align: center;
    box-sizing: border-box;
    padding: 20px 10px;
  }
  .footer-main p,.footer-main p a{
    color: white;
    font-size: 18px;
  }
  .footer-main p:nth-of-type(2){
    cursor: pointer;
    margin-top: 10px;
  }
  @media screen and (max-width: 1000px){
    .footer-main p{
      color: white;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue